import React from "react";
import ReactLoading from "react-loading";

export const LoadingMode = () => {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <ReactLoading type="cylon" color="#5AC8FA" height={44} width={44} />
    </div>
  );
};
